/**
 * Builds addUserItem variables for the floorplanner Add to project flow.
 * Omits productIds when the plan has no catalog Products.
 */
export function buildAddFloorplanUserItemVariables(input: {
  image: File;
  productIds: string[];
}): {
  image: File;
  removeBG: false;
  tags: ["floorplan"];
  productIds?: string[];
} {
  return {
    image: input.image,
    removeBG: false,
    tags: ["floorplan"],
    ...(input.productIds.length > 0 ? { productIds: input.productIds } : {}),
  };
}
